<template>
    <div id="ProductsQuicktable" class="pt-5 pb-5">

        <!-- <products-search-bar @search="refreshFromStart" :is-processing="!isProcessing" /> -->
        <!-- <pre>{{ term }}</pre> -->
        <!-- <pre>{{ catId }}</pre> -->

        <spinner v-if="isProcessing"></spinner>

        <template v-else>

            <!-- PRODUCTOS NO ENCONTRADOS -->
            <div class="no-products" v-if="emptyResults">
                <ui-iconify class="iconify-holder limit-width">
                    <h1>Ésta consulta no ha arrojado productos.</h1>
                    <p>
                        Cambia el criterio de búsqueda o contacta con el administrador
                        <br> del sitio para más información.
                    </p>
                </ui-iconify>
            </div>

            <!-- SECCIÓN DE PRODUCTOS -->
            <section class="container oversized-container" v-else>
                <div class="products-quicktable-wrapper">
                    <productItemApiFetched class="products-item" v-for="item in data.rows"
                        :key="'pID-' + item.productos_id" :productId="item.productos_id" :productData="item" />
                </div>
            </section>

        </template>

        <!-- UI DE PAGINADO -->
        <ui-paginator class="fix-to-bottom" v-if="!isProcessing && !emptyResults" mode="router"
            :items-length="parseInt(data.count)" 
            :page-size="parseInt(data.per_page)" />

    </div>
</template>

<script>

import _ from 'lodash'
import axios from 'axios';
import UiPaginator from '../shared/UiPaginator.vue';
import UiIconify from '../shared/UiIconify.vue';
import UiSearch from '../shared/UiSearch.vue';
import Navigation from './navigation.vue';
import productItemApiFetched from './productItemApiFetched.vue';
import { mapGetters } from 'vuex';

const name = 'ProductsQuicktable';

const components = {
    UiPaginator,
    UiSearch,
    UiIconify,
    Navigation,
    productItemApiFetched
};

import {
    notify,
    mixedMSG
} from '@@/utils.js'


const emptyData = {
    rows: [],
    count: 0,
    per_page: (2 * 3 * 5),    // 30 items per page
    page: 1,
    summaries: null
};

export default {
    name,
    components,
    props: {
        fetchingURI: {
            type: String,
            default: 'inventariocpt/index'
        }
    },
    data: () => {
        return {
            data: _.cloneDeep(emptyData),
            page: 1,
            term: '',
            catId: null,
            isProcessing: false
        }
    },
    computed: {
        ...mapGetters(['catalogCats']),
        emptyResults() {
            return (!this.data.rows || this.data.rows.length === 0);
        },
        cCats() {
            return this.catalogCats.map(cat => {
                return {
                    value: cat.id,
                    label: cat.categoria_nombre
                }
            })
        },
        cFetchingURI() {
            try {
                let term = 'none';
                let catId = 'all';
                if ((this.catId != 'all') && (this.catId != '@') && (this.catId != null))
                    catId = this.catId;
                if (this.term && this.term.trim() !== '')
                    term = encodeURIComponent(this.term.trim())
                return this.fetchingURI + '/' + this.data.per_page + '/' + (this.page || 1) + '/' + term + '/' + catId;
            } catch (e) {
                console.error(e)
                return this.fetchingURI
            }
        }
    },
    methods: {
        async refresh() {
            if (this.isProcessing) return; // solo una instancia de refresh a la vez
            await this._refresh()
        },
        async refreshFromStart() {
            this.page = 1;
            await this.refresh();
        },
        async _refresh() {
            this.isProcessing = true
            try {
                // UPDATE ROUTER QUERY PARAMS
                const response = await axios.get(this.cFetchingURI)
                if (!_.isObjectLike(response.data))
                    throw ('Respuesta inválida del servidor')
                mixedMSG(response.status, response.msg, response.class);
                if (response.status) {
                    this.data.rows = response.data.rows
                    this.data.count = response.data.count
                    this.data.summaries = response.data.summaries
                } else {
                    this.data = _.cloneDeep(emptyData)
                }
            } catch (e) {
                notify(e)
            } finally {
                // setTimeout(() => {
                    this.isProcessing = false
                    if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar)
                        setTimeout(window.app.__vue__.$refs.loadingBar.done, 900);
                // }, 900);
            }
        },
        _initDataModule() {
            try {
                this.term = (this.$route.query.term) ? this.$route.query.term : 'none';
                this.catId = (this.$route.query.catId) ? this.$route.query.catId : 'all';
                if (this.page != this.$route.query.page)
                    this.page = this.$route.query.page;
            } catch (e) {
                console.error(e)
            }
        }
    },
    watch: {
        page(newVal, oldVal) {
            // console.log('Page changed from', oldVal, 'to', newVal);
            // let query ={...this.$route.query};
            // query.page = newVal;
            // this.$router.replace({
            //     name: this.$route.name,
            //     query
            // });
        },
        '$route'(to, from) {
            console.log('Route changed, refreshing data...', to, from);
            this._initDataModule();
            this.refresh();
        }
    },
    async beforeMount() {
        this._initDataModule();
        await this.refresh()
    }
}
</script>

<style lang="scss">
@import '@/sass/utils/_variables';

#ProductsQuicktable {

    min-height: 68vh;
    position: relative;

    .no-products {
        width: 100%;
        height: calc(100% - 3.75em);
        position: absolute;
        background: linear-gradient(0deg, $primary-transparent, transparent);
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .limit-width {
        max-width: 1280px;
        max-width: 1366px;
    }

    .oversized-container {
        // max-width: 100vw;
    }

    .fix-to-bottom {
        margin-top: 30px;
        margin-bottom: 10px;
    }

    .products-quicktable-wrapper {
        gap: 20px;
        margin: 0;
        padding: 0;
        display: flex;
        flex-flow: row;
        flex-wrap: wrap;
        justify-content: center;

        .products-item {
            flex: 0 0 16em;

            @media screen and (max-width: 520px) {
                flex: 0 0 20em;
            }

            @media screen and (max-width: 480px) {
                font-size: 0.9em;
                flex: 0 1 20em;
            }

            // max-width: 12em;
            // width: auto;
        }


    }

}
</style>